import React, { useState } from 'react';
import { useEffect } from 'react';
import Header from '../components/Header';
import { getLoots } from '../service/api';


function Loots() {
  const [loots,setLoots] = useState([])

  useEffect(()=>{
    getLoots().then(response => {
      setLoots(response)
    })
  },[]);

  console.log(loots);

  return (
    <>
      <Header />
      <div className="card p-3 py-lg-10 col-12 col-lg-10 col-xxl-10 mx-auto">
          <table>
          <tbody>
            {loots.map((loot)=>(
              <tr key={loot.id}>
                <td width={90} className="p-2 border-bottom">
                  <img className="img-fluid rounded-circle user-portrait-img loot" src={loot.image} alt={loot.name} width={50} />
                </td>
                <td className="p-2 border-bottom">
                  <div className='title-h3'>{loot.name}</div>
                  <div className='fw-light lh-base description p-1'>
                   {loot.description}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
          </table>
      </div>
    </>
  )
}

export default Loots